<template >
<div  v-loading.fullscreen.lock="loading">
	<div v-if="user.type ==1"  class="box_aqa">
		<h3>您已是尊贵的VIP用户了！</h3>
		<div class="aqa_zi">
			<p>您可以:</p>
			<div>1.去<span class="lan" @click="xin.goUrl('/integral')">积分兑换</span></div>
			<div>2.去其他地方逛逛：<span class="lan" @click="xin.goUrl('/index')">首页</span></div>
		</div>
	</div>
	<div v-else class="msg_box">
		<div class="tech_title">
			VIP申请
		</div>
		<div class="clearfloat">
			<div class="vip_left">
				<el-form label-position="top" :model="ruleForm" :rules="rules" ref="ruleForm"  class="demo-ruleForm">
					<p class="p_from" v-if="user.open_id">微信号 <span class="mar_left_30">已绑定</span></p>
					<el-form-item v-if="!user.open_id" label="微信号" prop="wx">
						<button v-notClick="isBtn" class="laing_btn"  @click="erwm(user.key)">绑定</button>
					</el-form-item>
					<el-form-item label="姓名" prop="name">
						<el-input v-model="ruleForm.name" ></el-input>
					</el-form-item>
					<el-form-item label="单位" prop="unit">
						<el-autocomplete style="width:100%" class="inline-input" v-model="ruleForm.unit" :fetch-suggestions="querySearch"
						placeholder="试试搜索：清华" :trigger-on-focus="false"  @select="handleSelect" >
							<template slot-scope="{ item }">
								<div class="name">{{ item.name }}</div>
							</template>
						</el-autocomplete>
					</el-form-item>
					<el-form-item label="部门实验室（PI）" prop="team">
						<el-input v-model="ruleForm.team" ></el-input>
					</el-form-item>
					<el-form-item   label="课题方向" prop="team_direction">
						<el-input v-model="ruleForm.team_direction"></el-input>
					</el-form-item>
				</el-form>
				<el-form label-position="left" label-width="200px" :model="ruleForm" :rules="rules" ref="ruleForm2">
					<el-form-item label="默认发票信息" ></el-form-item>
					<el-form-item  label="专票/普通" prop="in_type">
						<el-radio-group v-model="ruleForm.in_type">
							<el-radio :label="1">专票</el-radio>
							<el-radio :label="2">普票</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="发票抬头" prop="in_look">
						<el-autocomplete style="width:100%" class="inline-input" v-model="ruleForm.in_look" :fetch-suggestions="querySearch2"
						placeholder="试试搜索：清华" :trigger-on-focus="false"  @select="(e)=>{ruleForm.in_look = e.name;ruleForm.in_identify = e.taxpayer_number;}" >
							<template slot-scope="{ item }">
								<div class="name">{{ item.name }}</div>
							</template>
						</el-autocomplete>
					</el-form-item>
					<el-form-item label="纳税人识别号" prop="in_identify">
						<el-input v-model="ruleForm.in_identify" ></el-input>
					</el-form-item>
					<el-form-item v-if="ruleForm.in_type!=2"  label="专票信息（普票无需填写）" prop="in_info">
						 <el-input type="textarea" v-model="ruleForm.in_info"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="vip_right">
				<el-form label-position="left" label-width="115px" :model="ruleForm" :rules="rules" ref="ruleForm3" >
					<el-form-item  label="实验地址" >
					</el-form-item>
					<el-form-item  label="收货人" prop="ad_name">
						<el-input v-model="ruleForm.ad_name"></el-input>
					</el-form-item>
					<el-form-item label="地区" prop="addrid">
						<el-cascader v-model="ruleForm.addrid" placeholder="试试搜索：上海市" :options="region"
						filterable expand-trigger="hover" clearable style="width:100%">
						</el-cascader>
					</el-form-item>
					<el-form-item label="详细地址" prop="ad_address">
						<el-input v-model="ruleForm.ad_address"></el-input>
					</el-form-item>
					<el-form-item label="手机" prop="ad_phone">
						<el-input v-model="ruleForm.ad_phone"></el-input>
					</el-form-item>
					<el-form-item label="或固定电话">
						<el-input v-model="ruleForm.ad_telephone"></el-input>
					</el-form-item>
					<el-form-item label="邮箱" prop="ad_email">
						<el-input v-model="ruleForm.ad_email"></el-input>
					</el-form-item>
					<el-form-item label="感兴趣的实验" prop="type">
						<el-checkbox-group v-model="ruleForm.type">
							<el-checkbox v-for="(item) in interestList" :key="item.id" :label="item.title">{{item.title}}</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="bot">
			<div v-show="isTosub" @click="addVip" class="laing_btn">申请</div>
		</div>
		<div class="vip_message clearfloat">
			<div class="left_message" v-html="vou_vip"></div>
			<div class="left_message" v-html="vip_apply"></div>
			<div class="left_message" v-html="vip_apply_way"></div>
		</div>
		<!-- 微信二维码 -->
		<el-dialog
		title="二维码绑定"
		:visible.sync="isErwm" :close-on-click-modal="false"
		center :before-close="closeErwm"
		width="500px">
			<div class="erwema">
				<!-- <div class="erm_biao">二维码绑定</div> -->
				<div class="erm_img">
					<img :src="ewm" alt="">
				</div>
				<p>扫二维码绑定微信号</p>
			</div>
		</el-dialog>
	</div>
</div>
</template>
<script>
import city from '@/utlis/city.js'
import {mapState,mapMutations,mapActions} from 'vuex'
export default {
	data(){
		return {
			isBtn:true,
			loading:false,
			isTosub:true,
			ewm:'',
			timeId:-1,
			key:'',
			err:'',
			isErwm:false,//二维码
			region: [],// 地址三级
			interestList: [],//感兴趣的实验
			vou_vip:"",//vip特惠
			vip_apply:"",//vip申请方法
			vip_apply_way :"",//vip要求
			ruleForm: {
				unit: '',//单位
				name:'',//姓名
				team:'',//课题组
				team_direction:'',//课题方向
				ad_name:"",//收货人
				ad_province_id:"",//省
				ad_city_id:"",//市
				ad_area_id:"",//区
				addrid:"",//地区
				ad_address:"",//详细地址
				ad_phone:"",//手机
				ad_telephone:"",//固定电话
				ad_email:"",//邮箱
				in_type:"",//发票类型
				in_look:"",//发票抬头
				in_identify:"",//发票纳税人识别号
				in_info:"",//发票信息
				type:[],//感兴趣实验
			},
			rules: {
				wx:{required: true, message: '请绑定微信公众号', trigger: 'change'},
				name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
				addrid:[{type: 'array', required: true, message: '请选择地区', trigger: 'change' }],
				unit: [{ required: true, message: '请输入单位', trigger: 'blur' }],
				team: {required: true, message: '部门实验室（PI）', trigger: 'blur'},
				team_direction:{required: true, message: '请输入课题方向', trigger: 'blur'},
				ad_name: {required: true, message: '请输入收货人', trigger: 'blur'},
				in_type: {required: true, message: '请选择发票类型', trigger: 'change'},
				ad_address: {required: true, message: '请输入详细地址', trigger: 'blur'},
				ad_email: {required: true, message: '请输入邮箱', trigger: 'blur'},
				in_look:[{ required: true, message: '请输入发票抬头', trigger: 'blur' }],
				in_identify: {required: true, message: '请输入纳税人识别号', trigger: 'blur'},
				in_info: {required: true, message: '请输入发票信息', trigger: 'blur'},
				ad_phone:{required: true, message: '请输入手机号', trigger: 'blur'},
				type: { type: 'array', required: true, message: '请至少选择一个感兴趣的实验', trigger: 'change' }
			}
		}
	},
	computed:{
		...mapState(['user','token'])
	},
	watch:{
		
	},
	beforeDestroy(){
		clearTimeout(this.timeId);
	},
	created(){
		if(this.user.type !=1){
			// this.Postaddresstree();
			this.region = this.asd(city.data||[])
			this.PostuserExperiment();
			this.PostuserCommon();
		}
	},
	methods:{
		...mapMutations(['settoken']),
		...mapActions(['getUser']),
		closeErwm(done ){
			clearTimeout(this.timeId);
			done();
		},
		async erwm(){//获取二维码
			try{
				this.isBtn = false;
				let {code:code1,data:res} = await this.api.GetUserBind_wx();
				if(code1==200){
					let {code,data} = await this.api.Postewm({ key:res.key ,token:this.token});
						if(code==200){
							this.isErwm = true;
							this.ewm = data.url;
							this.settime(data.key);
						}
				}
			} finally {
				this.isBtn = true;
			}
		},
		async settime(key) {//轮训
			this.timeId = setInterval(async()=>{
				let {code,data,message} = await this.api.Postgonzhohao({ key });
				if(code == 400){
				}else if(code==200){
					this.$message({ message: "微信绑定成功", type: "success" });
					clearTimeout(this.timeId);
					this.settoken(data.token);
					this.getUser();
					this.isErwm = false;
				}else{
					clearTimeout(this.timeId);
					this.err = message;
					this.isErwm = false;
				}
			},2000);
		},
		async PostuserCommon(){
			let {data} = await this.api.PostuserCommon({name:'vou_vip'});
			this.vou_vip = data;
			let {data:a} = await this.api.PostuserCommon({name:'vip_apply_way'});
			this.vip_apply = a;
			let {data:b} = await this.api.PostuserCommon({name:'vip_apply_ask'});
			this.vip_apply_way = b;
		},
		async addVip(){//申请vip
			this.$refs.ruleForm.validate(v1=>{
				this.$refs.ruleForm2.validate(v2=>{
					this.$refs.ruleForm3.validate(async v3=>{
						if(!v1||!v2||!v3)return;
				this.isTosub = false;
				let ruleForm = Object.assign({},this.ruleForm);
				ruleForm.ad_province_id = ruleForm.addrid[0];
				ruleForm.ad_city_id = ruleForm.addrid[1];
				ruleForm.ad_area_id = ruleForm.addrid[2];
				ruleForm.experiment = ruleForm.type.join(',');
				delete ruleForm.addrid;
				delete ruleForm.type;
				this.loading = true;
				let {code} = await this.api.PostuserAudit(ruleForm);
				if(code==200){
					this.$message({ message: '提交成功', type: 'success' });
					this.xin.goUrl("/personalCenter/personal")
				}
				this.isTosub = true;
				this.loading = false;
			});
			});
			});
		},
		async PostuserExperiment(){//获取感兴趣实验
				let {data} = await this.api.PostuserExperiment();
				this.interestList =data;
		},
		async querySearch(queryString, cb) {//单位搜索
			let {data} = await this.api.Postuserunit({title:queryString})
			cb(data);
		},
		async querySearch2(queryString, cb) {//单位搜索
			let {data} = await this.api.Postlook({title:queryString})
			cb(data);
		},
		handleSelect(e){//添加选择单位
			this.ruleForm.unit = e.name;
		},
		async Postaddresstree(){//获取省市区
			let {data} = await this.api.Postaddresstree();
			this.region = this.asd(data);
		},
		asd(list){//遍历
			return list.map((v,i)=>{
				v.label = v.name;
				v.value = v.id;
				if(v.datas){
					v.children = this.asd(v.datas);
					delete v.datas;
				}
				return v;
			})
		}
	}
}
</script>
<style lang="scss" scoped>
.p_from{
	font-size: 14px;
    color: #606266;
    line-height: 40px;
}
	.erwema{
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		// height: 500px;
		.erm_biao{
			font-size: 20px;
			color: #444444;
		}
		.erm_img{
			img{
			}
		}
		p{
			font-size: 14px;
			font-family: PingFangSC-Regular;
			color: #868788;
		}
	}
	.vip_message{
		font-size:16px;
		color: #666666;
		line-height: 36px;
		.left_message{
			float: left;
			margin: 0 20px;
			&:nth-child(1){
				width: 300px;
			}
			&:nth-child(2){
				width: 500px;
			}
			&:nth-child(3){
				width: 280px;
			}
			.msg_title{
				font-size: 20px;
				color: #333333;
				line-height: 36px;
			}
		}
	}
	.bot{
		.laing_btn{
			margin: 60px auto;
			width: 300px;
		}
	}
	.clearfloat{
		margin-top: 50px;
		.vip_left{
			float: left;
			width: 500px;
		}
		.vip_right{
			margin-left: 50px;
			width: 500px;
			float: left;
		}
	}
</style>